import createLucideIcon from '../createLucideIcon';

const PenTool = createLucideIcon('PenToolIcon', [
  ['path', { d: 'm12 19 7-7 3 3-7 7-3-3z', key: 'rklqx2' }],
  ['path', { d: 'm18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z', key: '1et58u' }],
  ['path', { d: 'm2 2 7.586 7.586', key: 'etlp93' }],
  ['circle', { cx: '11', cy: '11', r: '2', key: 'xmgehs' }],
]);

export default PenTool;
